import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderService } from '@app/services/order/order.service';
import { ScheduledialogComponent } from '../scheduledialog/scheduledialog.component';

@Component({
  selector: 'app-snooze',
  templateUrl: './snooze.component.html',
  styleUrls: ['./snooze.component.scss'],
  standalone: false,
})
export class SnoozeComponent implements OnInit {
  lastTimeSnoozed;
  isLoading = false;
  constructor(
    public dialogRef: MatDialogRef<SnoozeComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedOrders: any,
    public dialog: MatDialog,
    private orderService: OrderService,
  ) {}
  ngOnInit(): void {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(8);
    tomorrow.setMinutes(0);
    tomorrow.setMilliseconds(0);
    this.lastTimeSnoozed = tomorrow;
  }

  scheduleOrders() {
    if (!this.isLoading) {
      this.isLoading = true;
      this.orderService.scheduleOrders(this.selectedOrders, this.lastTimeSnoozed).then(() => {
        this.isLoading = false;
        this.dialogRef.close();
      });
    }
  }

  openCalendar() {
    if (!this.isLoading) {
      this.dialogRef.close();
      this.dialog.open(ScheduledialogComponent, {
        height: '500px',
        width: '612px',
        panelClass: 'schedule_popup',
        backdropClass: 'global_modal_overlay',
        data: this.selectedOrders,
        disableClose: true,
      });
    }
  }

  close() {
    if (!this.isLoading) {
      this.dialogRef.close();
    }
  }
}
